/**
 * The valid recipe types
 * @type {Object}
 */
const recipeTypes = {
    user: {
        id: 'user',
        name: _uo.utility.escHTML( wp.i18n.__( 'Logged-in users', 'uncanny-automator' ) ),
        description: _uo.utility.escHTML( wp.i18n.__( 'Recipe will be triggered by logged-in WordPress users.', 'uncanny-automator' ) ),
    },
    anonymous: {
        id: 'anonymous',
        name: _uo.utility.escHTML( wp.i18n.__( 'Everyone', 'uncanny-automator' ) ),
        description: _uo.utility.escHTML( wp.i18n.__( 'Recipe will be triggered by logged-in WordPress users or logged out visitors.', 'uncanny-automator' ) ),
    },
};

export default recipeTypes;
